import {QueryKeys} from '../../../queryDefaults/QueryKeys';
import {useMutation} from '@tanstack/react-query';
import {AppMedError} from '../../../error/AppMedError.ts';
import {ISimulationPayload} from '../Simulation.ts';
import {SimulationApi} from '../../../apis/SimulationApi/SimulationApi.ts';

export function usePostSimulationMutation() {
    return useMutation<number, AppMedError, ISimulationPayload>({
        mutationKey: [QueryKeys.simulation],
        mutationFn: async (variables: ISimulationPayload) => {
            return await SimulationApi.postSimulation(variables);
        },
    });
}